<template>
  <canvas :height="height" :width="width" id="financements-percus-graph"></canvas>
</template>
<script>
import {SOLUTIA} from "@/constants/Colors";
import {Chart} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {arrondirKeuros} from "@/util";

export default {
  name: "FinancementsPercusCTMGraph",
  props: {
    data: Array,
    height: {
      type: Number,
      default: 600,
    },
    width: {
      type: Number,
      default: 600,
    }
  },
  mounted: async function () {
    let that = this;

    let statusFetchStatus = this.$store.getters["dossier/statuts/statut_fetch_status"];
    if (statusFetchStatus === "INITIAL" || statusFetchStatus === "ERROR") {
      await this.$store.dispatch("dossier/statuts/getStatuts");
    }
    // eslint-disable-next-line no-unused-vars
    const chartData = {
      label: "Financements perçus CTM",
      labels: this.data.map(data_of_year => data_of_year.year),
      datasets: [
        {
          label: "Total perçus",
          data: this.data.map(data_of_year => arrondirKeuros(data_of_year.total_paye_ctm)),
          datalabels: {
            color: '#ffffff',
            display: function (context) {
              return context.dataset.data[context.dataIndex] > 0;
            },
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[0]
        },
        {
          label: "Restant à demander notifié",
          data: this.data.map(data_of_year => arrondirKeuros(data_of_year.reste_a_payer_ctm_notifie)),
          datalabels: {
            color: '#ffffff',
            display: function (context) {
              return context.dataset.data[context.dataIndex] > 0;
            },
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[1]
        },
        {
          label: "Restant à demander non notifié",
          data: this.data.map(data_of_year => arrondirKeuros(data_of_year.reste_a_payer_ctm_non_notifie)),
          datalabels: {
            color: '#ffffff',
            display: function (context) {
              return context.dataset.data[context.dataIndex] > 0;
            },
            font: {
              size: 16
            }
          },
          backgroundColor: "#800020"
        },
        {
          label: "TOTAL",
          tooltip: {
            enabled: false
          },
          data: this.data.map((data_of_year) => arrondirKeuros(data_of_year.total_financements_ctm / 10)),
          datalabels: {
            color: 'black',
            clamp: true,
            anchor: "end",
            formatter: function (value, context) {
              return arrondirKeuros(that.data[context.dataIndex].total_financements_ctm);
            },
            font: {
              size: 16,
              weight: "bold"
            }
          },
          backgroundColor: "#ffffff00"
        },
      ],
    }
    // eslint-disable-next-line no-unused-vars
    const config = {
      title: {
        display: true,
        text: "Suivi des financements CTM",
        fontSize: 16,
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
          }
        }],
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false,
          }
        }]
      },
    }
    this.$nextTick(function () {
      const ctx = document.getElementById('financements-percus-graph');
      that.chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "bar",
        //...defaultData
        data: chartData,
        options: config,
      });
    })
  },
  data: function () {
    return {
      chart: null
    }
  },
  computed: {
    statuts() {
      return this.$store.getters["dossier/statuts/statuts"];
    },
  },
  methods: {}
}
</script>

<style scoped>

</style>